import React from "react";
//#region redux
import { useDispatch } from "react-redux";
import { stoppedPaymentsReportCompleted, stoppedPaymentsReportUpdated } from "store/actions/stoppedPaymentsActions";
//#endregion
//#region types
import { StyleEnums } from "models/enums";
import { TranslationKeys } from "translations";
import { StoppedPaymentsFooterProps } from "models/propTypes/paymentPropTypes";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { PaymentFormTypes } from "models/formTypes";
//#endregion
//#region components
import { PageFooter } from "components/common";
import { useStoppedPaymentsService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const StoppedPaymentsFooter: React.FC<StoppedPaymentsFooterProps> = (props) => {
  const stoppedPaymentsService = useStoppedPaymentsService();
  const { selectedPayments, disableSuccessMessages } = props;
  const dispatch = useDispatch();

  const onPaymentsAccept = () => {
    return props.rescheduleFormSubmitHandler((values: PaymentFormTypes.StoppedPaymentTodo) => {
      const paymentsToSign: WintSuperkollAPIModel.RescheduleStoppedPayments = {
        stoppedPaymentListToReschedule: selectedPayments.map(
          (p): WintSuperkollAPIModel.StoppedPaymentMeta => ({ type: p.type, id: p.id })
        ),
        newDate: values.newPayoutDate,
      };
      return stoppedPaymentsService.approveStoppedPayments(paymentsToSign);
    });
  };

  const onAcceptSuccess = () => {
    props.reloadHandler &&
      props.reloadHandler((payments) => {
        if (payments && payments.stoppedPaymentList && payments.stoppedPaymentList.length > 0) {
          dispatch(stoppedPaymentsReportUpdated(payments));
        } else {
          dispatch(stoppedPaymentsReportCompleted(0));
        }
      });
  };

  return (
    <PageFooter
      actions={[
        {
          text: `${LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.Payments.Pay
          )}${` (${selectedPayments.length})`}`,
          onClick: onPaymentsAccept,
          type: StyleEnums.DisplayType.Success,
          successMessage: LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.Payments.StoppedPaymentRescheduleSuccess
          ),
          onActionSuccess: onAcceptSuccess,
        },
      ]}
      disableSuccessMessages={disableSuccessMessages}
    />
  );
};

export default StoppedPaymentsFooter;
